import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@mobile/index.css";
import { Toaster } from "sonner";
import { AppRoutes } from "@mobile/app/routes";
import { preRenderSetup } from "@mobile/init";
import { ModalProvider } from "@mobile/features/modal";
import { DebugPanel } from "@mobile/features/debug/debug-panel";
import { listenForSwUpdate } from "@mobile/lib/sw-update";
import { SentryFallback } from "@mobile/components/ui/sentry-fallback";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
    },
  },
});

const el = document.getElementById("root");
if (el) {
  preRenderSetup();
  const root = createRoot(el);
  root.render(
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
          <Toaster
            position="top-center"
            expand={false}
            visibleToasts={3}
            gap={8}
            toastOptions={{
              unstyled: true,
            }}
          />
          <ModalProvider />
          <DebugPanel />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>,
  );
  listenForSwUpdate();
} else {
  throw new Error("Could not find root element");
}
